import { BankAccountStoreState } from '@/interfaces/bank-account';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  state: {
    bank_details: {}
  } as BankAccountStoreState,
  actions,
  getters,
  mutations,
};
